"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AuthProvider_1 = require("../AuthProvider");
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const hookrouter_1 = require("hookrouter");
const ElevatedView_1 = __importDefault(require("../ElevatedView"));
const LogoutPage = () => {
    const auth = AuthProvider_1.useAuth();
    return react_1.default.createElement(office_ui_fabric_react_1.Stack, { verticalAlign: "center", horizontalAlign: "center", verticalFill: true },
        react_1.default.createElement(ElevatedView_1.default, { depth: 16, style: { padding: 55, width: '400px', maxWidth: '90%', textAlign: 'center' } },
            react_1.default.createElement(office_ui_fabric_react_1.Text, { variant: "xxLarge" }, "Sign out"),
            auth.isAuthenticated
                ? react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("p", null, "Are you sure you want to sign out?"),
                    react_1.default.createElement(office_ui_fabric_react_1.Stack, { horizontal: true, gap: 15, horizontalAlign: "center" },
                        react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { onClick: () => auth.logout() }, "Yes"),
                        react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { onClick: () => hookrouter_1.navigate('/') }, "No")))
                : react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("p", null, "You have been signed out."),
                    react_1.default.createElement(office_ui_fabric_react_1.Stack, { horizontal: true, gap: 15, horizontalAlign: "center" },
                        react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { onClick: () => hookrouter_1.navigate('/login') }, "Login")))));
};
exports.default = LogoutPage;
